module.exports = __webpack_public_path__ + "static/media/blogosaurus.d16dbf34.png";